import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiFolder, FiBriefcase, FiList, FiDollarSign, FiArrowDownLeft, FiArrowUpRight, FiChevronDown, FiChevronRight } from 'react-icons/fi';

export default function BankSidebar() {
  const location = useLocation();
  const [openSections, setOpenSections] = useState({
    bank_cash: true,
    payments: true
  });

  const isActive = (path) => {
    return location.pathname.startsWith(path) ? 'bg-[#b2ebf2] font-bold text-[#0000a0]' : 'text-gray-700 hover:bg-[#b2ebf2] hover:text-[#0000a0]';
  };

  const toggleSection = (section) => {
    setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <div className="w-56 bg-[#e0f7fa] border-r border-teal-200 hidden md:flex flex-col flex-shrink-0">
      <div className="p-3 text-[14px] font-bold text-teal-900 border-b border-teal-200 bg-[#a6e4e7] uppercase tracking-wide">
        Bank & Cash
      </div>
      <div className="flex-1 overflow-y-auto py-2">
        
        {/* Bank / Cash Section */}
        <div className="mb-1">
          <div className="flex items-center px-3 py-1.5 text-[13px] font-bold text-gray-800 cursor-pointer hover:bg-teal-100 transition-colors select-none" onClick={() => toggleSection('bank_cash')}>
            {openSections.bank_cash ? <FiChevronDown className="mr-1 text-gray-500" /> : <FiChevronRight className="mr-1 text-gray-500" />}
            <FiFolder className="mr-1.5 text-yellow-500 fill-current" /> Bank / Cash
          </div>
          {openSections.bank_cash && (
            <ul className="text-[13px] pl-8 space-y-0.5 mt-0.5">
              <li>
                <Link to="/bank/accounts" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/bank/accounts')}`}>
                  <FiBriefcase className="mr-2 opacity-60 text-teal-800" /> Bank Accounts
                </Link>
              </li>
              <li>
                <Link to="/bank/transactions" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/bank/transactions')}`}>
                  <FiList className="mr-2 opacity-60 text-teal-800" /> Transactions
                </Link>
              </li>
            </ul>
          )}
        </div>

        <div className="my-2 border-t border-teal-200 mx-2"></div>

        {/* Payments Section */}
        <div className="mb-1">
          <div className="flex items-center px-3 py-1.5 text-[13px] font-bold text-gray-800 cursor-pointer hover:bg-teal-100 transition-colors select-none" onClick={() => toggleSection('payments')}>
            {openSections.payments ? <FiChevronDown className="mr-1 text-gray-500" /> : <FiChevronRight className="mr-1 text-gray-500" />}
            <FiFolder className="mr-1.5 text-yellow-500 fill-current" /> Payments
          </div>
          {openSections.payments && (
            <ul className="text-[13px] pl-8 space-y-0.5 mt-0.5">
              <li>
                <Link to="/accounting/misc-payments" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/misc-payments')}`}>
                  <FiDollarSign className="mr-2 opacity-60 text-teal-800" /> Misc Payments
                </Link>
              </li>
              <li>
                <Link to="/invoice/pay-customer" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/invoice/pay-customer')}`}>
                  <FiArrowDownLeft className="mr-2 opacity-60 text-teal-800" /> Customer Payments
                </Link>
              </li>
              <li>
                <Link to="/invoice/pay-supplier" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/invoice/pay-supplier')}`}>
                  <FiArrowUpRight className="mr-2 opacity-60 text-teal-800" /> Supplier Payments
                </Link>
              </li>
            </ul>
          )}
        </div>

      </div>
    </div>
  );
}